//import s from './style.module.scss';
import ep from './ep.module.scss';
import tac from './tac.module.scss';
//ep.module.scss
import {wpUser,production} from '../../../../k';
import Input2 from '../../../components/input2';
import Input1 from '../../../components/input';
import { useRef, useState, useEffect } from 'react';
import SubmitBtn from '../../../components/submit';
import { loaderPostFetch } from '../util';
import SendNotice from '../../../components/sendnotice';

import PinInput from "react-pin-input";
import { useActionData, useSubmit, useLocation,useNavigate } from 'react-router-dom';

import Card, { Card2 } from '../../../components/card';
import TextAr from '../../../components/textarea';

//TransferSubmitted

import TransferSubmitted from '../w19f/submitted'; 

import Notif from '../../../components/notif';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';

export async function epaction({ request, params }) {
  const formData = await request.formData();
  let nformData = new FormData();
  let extras = JSON.parse(formData.get('extra'));
  console.log({ extras });
  Object.keys(extras).forEach((j) => {
    nformData.append(j, extras[j]);
  }); 
  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    nformData.append('token', tok);
  } 
  const contact = await loaderPostFetch(`api/users.php`, nformData);
  //return contact;
  return {...contact,...extras};

  /*
  //loader will fetch details
  const formData = await request.formData();

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const updates = Object.fromEntries(formData);

  //const contact = await loaderPostFetch(`api/users.php`, formData);

  return updates;*/

}

export async function eploader({ params }) {

  const formData = new FormData();
  formData.append('gettrslist', 'gettrslist');

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const perc2 = await loaderPostFetch(`api/users.php`, formData);

  const formData2 = new FormData();
  formData2.append('getperc', 'getperc');
  if (tok != null) {
    formData2.append('token', tok);
  }
  const perc = await loaderPostFetch(`api/users.php`, formData2);
 
 /*
  const formData = new FormData();
  formData.append('getperc', 'getperc');

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const perc = await loaderPostFetch(`api/users.php`, formData);
*/
  //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
  return { ...params, perc, ...perc2 };
}

export default function EnterPin() {
  const { state } = useLocation();
  const submit = useSubmit();
  
  //const { perc, trx_notif } = useLoaderData();
  const navigate = useNavigate();

  let actionData = useActionData();

  const [n, sN] = useState({ display: false, type: 'success', msg: '' });
const [no, sNo] = useState(false);

  useEffect(() => {
    //console.log({ state, perc });
     console.log({ state });
  }, [state]);
  //tb


  const [showDone, sshowDone] = useState(false);
  useEffect(() => {
    /*console.log({ actionData });*/
    if (actionData) {
      let s = actionData;
      console.log(s);
      if (s?.icon) {
        if (s?.icon=="success") {
          sshowDone(true);
          //sN({ ...n, type: 'success', msg: 'Successful! Await Confirmation' });
          //setTimeout(() => {window.location.href = `../../dashboard`;}, 3000);
        } else {
          sNo(s?.trx_notif);
          //sN({ ...n, type: 'error', msg: 'Something went wrong!' });
        }
      }
      
      setTimeout(() => {
        sN({ display: false, type: 'success', msg: `` });
      }, 2000);
      
    }
  }, [actionData]);

  /*useEffect(() => {
    
    if (actionData) {
      let s = actionData;
      if (s?.icon) {
        if (s?.icon=="success") {
          sN({ ...n, type: 'success', msg: 'Successful! Await Confirmation' });
          window.location.href = `../`;
        } else {
          sNo(s?.trx_notif);
          //sN({ ...n, type: 'error', msg: 'Something went wrong!' });
        }
      }
       
      setTimeout(() => {
        sN({ display: false, type: 'success', msg: `` });
      }, 5000);
    }
  }, [actionData]);*/

  let ele = useRef();

  let ele2 = useRef();

  const [tpc, setTpc] = useState(false);

  const [pin, setPin] = useState("");

  const [he, setHe] = useState(false);
  const [bo, setBo] = useState(false);

  const handlePinComplete = (value) => {
    
    setPin(value);
    /*if (sub) {
      setDis(false);
    }else{
      setCPin(value);
    }*/
  };

  const handlePinComplete2 = (value) => {
    
    setPin(value);
    /*if (sub) {
      setDis(false);
    }else{
      setCPin(value);
    }*/
  };

  const sbtnref = useRef();

  const confirmyourpin=()=>{
    if (typeof pin=="undefined") {
      sN({ display: true, type: 'error', msg: 'Invalid Pin' }); 
    }else{
      const formData = new FormData();

      let tok = window.localStorage.getItem('baUid');
      if (tok != null) {
        formData.append('pin', pin);
        formData.append('token', tok);
        formData.append('confirmmypin', 'confirmmypin');
        loaderPostFetch(`api/users.php`, formData).then((b)=>{

          if (b?.status) {
            sN({ display: true, type: 'success', msg: 'Action Successful!' });
            //ele.clear();
            if (b?.requiresanother) {
              setTpc(true);

              setHe(b?.requiresanother?.head);
              setBo(b?.requiresanother?.body);
            }else{
              submit(sbtnref.current);
            }
             
          }else{
            sN({ display: true, type: 'error', msg: b?.message });
            ele2.clear();


          }
      
        }).catch((e)=>{

          sN({ display: true, type: 'error', msg: 'An error has Occured.' });
          ele2.clear();
          setPin(undefined);
      
        });

      }
    }

    setTimeout(() => {
      sN({ display: false, type: 'success', msg: `` });
      //go to next pin
      //window.location.href = `${wpUser}/dashboard`;
    }, 15000);

  }

  const confirmtranspin=()=>{
    if (typeof pin=="undefined") {
      sN({ display: true, type: 'error', msg: 'Invalid Pin' }); 
    }else{
      const formData = new FormData();

      let tok = window.localStorage.getItem('baUid');
      if (tok != null) {
        formData.append('pin', pin);
        formData.append('token', tok);
        formData.append('confirmtpin', 'confirmtpin');
        loaderPostFetch(`api/users.php`, formData).then((b)=>{

          if (b?.status) {
            sN({ display: true, type: 'success', msg: 'Action Successful!' });
            //ele.clear();
            
            submit(sbtnref.current);

            setTimeout(()=>{ 
              //window.location.href = '/wp-user/dashboard';
              window.location.href = '/wp-user/';
            },5000);
            
          }else{
            sN({ display: true, type: 'error', msg: b?.message });
            ele.clear();
            setPin(undefined);

          }
      
        }).catch((e)=>{

          sN({ display: true, type: 'error', msg: 'An error has Occured.' });
          ele.clear();
          setPin(undefined);
      
        });

      }
    }

    setTimeout(() => {
      sN({ display: false, type: 'success', msg: `` });
      //go to next pin
      //window.location.href = `${wpUser}/dashboard`;
    }, 15000);

  }

  const [newAmount, sNewAmount] = useState(Number(state?.amount));

  const DateDisplay = () => {
    const date = new Date();
    
    // Format the date as 'Mar 22, 2023'
    const formattedDate = date.toLocaleDateString('en-US', {
      month: 'short', // 'short' gives us the abbreviated month name (e.g., Mar)
      day: 'numeric',
      year: 'numeric'
    });return formattedDate;
  };
  const Confirmed=()=>{
    //window.location.href = `../../dashboard`;
    window.location.href = '/wp-user/';
  }

  return (
    <>
      <Notif display={n?.display} type={n?.type} msg={n?.msg} />

      {showDone?<TransferSubmitted 
        bank={actionData?.bank||''}
        date={DateDisplay()}
        name={actionData?.act_hold_name}
        paymentMethod="Bank Transfer"
        amount={`${actionData?.currency}${actionData?.amount}`} 
        amount1={`${actionData?.amount}`}
        currency={`${actionData?.currency}`}
        onConfirm={() => {Confirmed();console.log('Confirmed');}} />:<>

      {no?<SendNotice display={true} 
        t={no?.[0]?.title} 
        b={no?.[0]?.body} />:null}

      <div>
        <div  style={{ marginBottom: '1rem' }}>
           
          {/*className={s.h} JSON.stringify({...state})*/}
        </div>


        {(tpc)?<div className={tac.tac}>
        <div className={tac.card}>
          <div className={tac.icon}></div>
          <div className={tac.hea} style={{'whiteSpace': 'pre-line','padding':'0px 1.5rem'}}>{he?he:'Transfer Authorization Code is required'}</div>

          <PinInput
            ref={(n) => (ele = n)} /*Set ref */
            onComplete={handlePinComplete}
            length={4}
            focus
            inputMode="number"
            secret
            secretDelay={500}
            inputStyle={{
              border: "2px solid #3498db", // Customize the border color
              borderRadius: "8px", // Adjust border radius
              fontSize: "14px", // Change font size
              fontStyle: "normal",
              fontFamily: "Inter",
              fontWeight: "500",
              padding: "5px", // Add some padding
              margin: "5px", // Adjust margin
            }}
            inputFocusStyle={{ borderColor: "lightgray" }}
          />

          <div className={tac.btn} onClick={confirmtranspin}>Confirm</div>

          <div className={tac.txt} style={{'whiteSpace': 'pre-line','padding':'0px 1.5rem'}}>
          {bo?bo:''}
          {/*
          To ensure the security of your account and protect against <br/>unauthorized transactions, a transfer authorization code is <br/>required. 
<br/><br/>
This code helps verify your identity and confirm that you <br/>have authorized the transfer request.<br/>
Thank you for your cooperation.*/}
</div>


        </div></div>:<>

        <div className={ep.cardd} >

          <div className={ep.c}>
            <div className={ep.icon}></div>
          </div>


          <div className={ep.t}>Transaction PIN</div>
          <div className={ep.s} >To complete this transaction, please enter your <br/>
          4-Digital transaction PIN</div>

        {/*color: $color-black;
        text-align: center;
        font-feature-settings: 'clig' off, 'liga' off; 
        line-height: 22.479px; 
        letter-spacing: -0.899px;
        */}

          <PinInput
            ref={(n) => (ele2 = n)} /*Set ref */
            onComplete={handlePinComplete2}
            length={4}
            focus
            inputMode="number"
            secret
            secretDelay={500}
            inputStyle={{
              border: "2px solid #3498db", // Customize the border color
              borderRadius: "8px", // Adjust border radius
              fontSize: "14px", // Change font size
              fontStyle: "normal",
              fontFamily: "Inter",
              fontWeight: "500",
              padding: "5px", // Add some padding
              margin: "5px", // Adjust margin
            }}
            inputFocusStyle={{ borderColor: "lightgray" }}
          />
           <div className={ep.btnn} onClick={confirmyourpin} >Confirm</div>
           </div>
           </>}

        <Form method="post">

          <input type="hidden" name="newtrs" value="newtrs" />

          <input type="hidden" name="extra" value={JSON.stringify({ ...state })} />
 
          <button ref={sbtnref} type="submit" style={{'visibility':'hidden'}} /> 

        </Form>
      </div></>}
    </>
  );
}
